/**
 * On page load
 **/
$(document).ready( function(){
	MobileNav();
	ToggleSearchBar();
    ToggleImageCaptions();
});

function MobileNav(){
    $('.hamburglar').click( function(){
    	$(this).toggleClass('open');
          $('.mainnav').toggleClass('open');
    });
}

function ToggleSearchBar(){
    
    $('.mainnav #SearchForm_SearchForm_action_results').stop().click(function(e){
        
        if($(this).hasClass('ready')){
            // don't do nuffin
        }else{
            e.preventDefault();
            $('.mainnav #SearchForm_SearchForm_Search').animate(
                {right: "30px"},
                250
            );
            $(this).toggleClass('ready');
        }
        
    });
    
}

function ToggleImageCaptions(){
    
    $('.credited-image .toggle').stop().click(function(){
        
        var target = $(this).siblings('.details');
        
        if($(this).hasClass('fadein')){
            target.fadeIn(100);
        }else{
            target.fadeOut(100);
        }
        
        $(this).toggleClass('fadein fadeout');
        
    });
    
}



//////////////////
// WEBPACK FOOTER
// ./site/js/components/navigation.js
// module id = 3
// module chunks = 0